import React from "react";
import { Grid, Box, Button } from "@mui/material";

function UtilityButtons({
  selectedSinglePageFileIds,
  selectedMultiPageFileIds,
  loading,
  handleUploadDocument,
  handleSingleClassify,
  handleBatchPredict,
  handleMultiPageClassify,
  setLoading,
  setError,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: 2,
      }}
    >
      {/* ─── Under “Accreditation Areas” ─── */}
      <Box sx={{ width: 250, flexShrink: 0, marginLeft: 5 }}>
        <Button variant="contained" onClick={handleUploadDocument}>
          Upload Document
        </Button>
      </Box>

      {/* ─── Under “Single Page Documents” ─── */}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          marginRight: 40,
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            console.log(
              "Single Classify button clicked with file ID:",
              selectedSinglePageFileIds[0]
            );
            handleSingleClassify(selectedSinglePageFileIds[0]);
          }}
          disabled={loading || selectedSinglePageFileIds.length !== 1}
          sx={{
            marginRight: 2,
          }}
        >
          Single Classify
        </Button>
        <Button
          variant="contained"
          onClick={() => handleBatchPredict(selectedSinglePageFileIds)}
          disabled={loading || selectedSinglePageFileIds.length < 2}
        >
          Batch Classify
        </Button>
      </Box>

      {/* ─── Under “Multi Page Documents” ─── */}
      <Box
        /* match whatever width you gave your multi-page panel in FileListArea */
        sx={{
          width: 300,
          flexShrink: 0,
          marginRight: 15,
        }}
      >
        <Button
          variant="contained"
          onClick={handleMultiPageClassify}
          disabled={loading || selectedMultiPageFileIds.length === 0}
        >
          Classify
        </Button>
      </Box>
    </Box>
  );
}

export default UtilityButtons;
